import { render, staticRenderFns } from "./PageCondominiums.vue?vue&type=template&id=4b433db6"
import script from "./PageCondominiums.vue?vue&type=script&lang=js"
export * from "./PageCondominiums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports